import OadpBusinessTable from './oadp-business-table';
export default OadpBusinessTable;
